import { BACKEND_URI, fetchWithAuthRetry, getHeaders } from "./_shared"

/**
 * QUERY: Exports parser session data to Excel format
 * @param idToken - Authentication token
 * @param sessionId - Session ID to export
 * @returns Response with Excel file blob
 * @category Query
 */
export async function exportExcelApi(
  idToken: string | undefined,
  sessionId: string
): Promise<Response> {
  return fetchWithAuthRetry(
    `${BACKEND_URI}/parser/export-excel?session_id=${sessionId}`,
    {
      method: "GET",
      headers: getHeaders(idToken),
      credentials: "include",
    },
    idToken
  )
}
